var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#F1A33A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7285 16.5992C23.7285 15.9954 23.2396 15.5059 22.6365 15.5059H11.8906C11.2875 15.5059 10.7986 15.9954 10.7986 16.5992C10.7986 17.203 11.2875 17.6925 11.8906 17.6925H22.6365C23.2396 17.6925 23.7285 17.203 23.7285 16.5992Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4087 15.8261C22.9822 15.3991 22.2907 15.3991 21.8643 15.8261L18.2823 19.4122C17.8558 19.8392 17.8558 20.5315 18.2823 20.9584C18.7088 21.3854 19.4002 21.3854 19.8267 20.9584L23.4087 17.3723C23.8351 16.9453 23.8351 16.2531 23.4087 15.8261Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2823 12.2402C17.8558 12.6671 17.8558 13.3594 18.2823 13.7864L21.8643 17.3725C22.2907 17.7995 22.9822 17.7995 23.4087 17.3725C23.8351 16.9455 23.8351 16.2533 23.4087 15.8263L19.8267 12.2402C19.4002 11.8132 18.7088 11.8132 18.2823 12.2402Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightFilled);
export default __webpack_public_path__ + "static/media/arrow-right-filled.11a07329fe70baeafa1744d3becfa3e3.svg";
export { ForwardRef as ReactComponent };